import { Box } from '@jfs/ui-new'
import { useCallback, useEffect, useRef } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../../../components/Container'
import { NewTable } from '../../../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../../../data/store'
import { Pagination } from '../../../../FraudAndRiskManagement/Pagination'

export const InteractionHistoryList = ({ merchantId }: any) => {
  const {
    fetchInteractionHistoryList,
    pagination,
    setPagination,
    downloadInteractionHistoryDocsAsync,
    resetPagination,
  } = useStores((store) => ({
    fetchInteractionHistoryList: store.entityOnboarding.fetchInteractionHistoryList,
    downloadInteractionHistoryDocsAsync: store.entityOnboarding.downloadInteractionHistoryDocsAsync,
    pagination: store.pagination,
    setPagination: store.setPagination,
    resetPagination: store?.resetPagination,
  }))
  const abortControllerRef = useRef(null)
  const { width } = useWindowDimensions()

  const [lazyFetchInteractionHistoryList, fetchInteractionHistoryListHandler] =
    useLazyApiData(fetchInteractionHistoryList)

  const fetchInteractionHistory = useCallback(() => {
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    lazyFetchInteractionHistoryList(merchantId, abortControllerRef.current)
  }, [])

  useEffect(() => {
    resetPagination()
    fetchInteractionHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onPageClick = useCallback((number: number) => {
    setPagination({ ...pagination, number })
    fetchInteractionHistory()
  }, [])

  const onItemCountSelect = useCallback((count: string) => {
    setPagination({ ...pagination, number: 1, size: parseInt(count, 10) })
    fetchInteractionHistory()
  }, [])

  return (
    <Container
      isLoading={fetchInteractionHistoryListHandler?.state === 'pending'}
      errorMessage={fetchInteractionHistoryListHandler?.data?.message}
      emptyMessage={
        fetchInteractionHistoryListHandler?.state === 'fulfilled' &&
        fetchInteractionHistoryListHandler?.data?.length === 0 &&
        'Interaction History not found'
      }
      onRetry={fetchInteractionHistory}>
      <Box f={1}>
        <NewTable
          data={fetchInteractionHistoryListHandler?.data ?? []}
          rowHeight={48}
          headerHeight={64}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={checker1HeaderTitles}
          onRetry={() => {}}
          onRowClick={() => {}}
          onAction={(action, id, rowData) => {
            console.log('htag action,id,rowData', action, id, rowData)
            abortControllerRef?.current?.abort()
            abortControllerRef.current = new AbortController()
            downloadInteractionHistoryDocsAsync(
              {
                mid: merchantId,
                requestId: rowData?.requestId,
              },
              abortControllerRef.current,
            )
          }}
          commentsData={[
            { key: 'createAt', heading: 'Date & Time' },
            { key: 'requestId', heading: 'Request Id' },
            { key: 'makerUserName', heading: 'Maker' },
            { key: 'checkerUserName', heading: 'Checker' },
            { key: 'actionType', heading: 'Action Type' },
            { key: '', heading: '' },
            { key: 'commentsDetails', heading: 'Comments' },
          ]}
          showDefaultExpandedCommentView={true}
        />
      </Box>
      <Pagination
        dataWindow={pagination.size}
        onPageClick={onPageClick}
        onItemsCountSelect={onItemCountSelect}
        pageNumber={pagination.number}
        totalPages={Math.ceil(pagination.totalElements / pagination.size)}
        total={pagination.totalElements}
      />
    </Container>
  )
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    createAt: 80,
    requestId: 150,
    makerUserName: 120,
    checkerUserName: 120,
    actionType: 80,
    comments: 150,
    applicationStatus: 80,
    documents: 80,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export const checker1HeaderTitles = {
  createAt: 'Date & Time',
  requestId: 'Application ID',
  makerUserName: 'Maker',
  checkerUserName: 'Checker',
  actionType: 'Action Type',
  comments: 'Comments',
  actionDownload: 'Documents',
}
